import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from '@material-ui/core/IconButton';
import { DeleteOutline } from '@material-ui/icons';
import { addQueryWithReplace } from 'Helpers/Query';
import { STEP_LINK_QUERY_PARAM_NAME, useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';

const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
  },
  deleteButton: {
    margin: 'auto',
    backgroundColor: theme.palette.facet.accentRed3,
  },
  deleteIcon: {
    color: theme.palette.facet.red,
  },
});

const RemoveButton = ({
  className,
  classes,
  resource,
  dialogProps,
  loadPreviousResource,
  ...rest
}) => {
  const {
    setOnboardingStepCollection,
    loadPreviousOnboardingStepCollection,
  } = useSurveyContext();

  const {
    title,
    message,
    cancelLabel,
    confirmLabel,
  } = dialogProps;

  const onRemove = async () => {
    // delete the resource
    const coll = await resource.delete();
    const [nextStepResource] = coll;

    if (loadPreviousResource) {
      loadPreviousOnboardingStepCollection();
    } else {
      // push next link as next step
      addQueryWithReplace({ [STEP_LINK_QUERY_PARAM_NAME]: nextStepResource.link('self').url() });
      setOnboardingStepCollection(coll);
    }
  };

  const {
    dialogOpen,
    loading,
    handleClose,
    handleSubmit,
    handleOpen,
  } = useConfirmationDialogState({
    onSubmit: onRemove,
  });

  const canDelete = resource.id() > 0 && resource.meta().action('DELETE');

  if (!canDelete) return null;
  return (
    <div className={classNames(classes.root, className)}>
      <IconButton
        className={classes.deleteButton}
        onClick={handleOpen}
        color="error"
        {...rest}
      >
        <DeleteOutline className={classes.deleteIcon} />
      </IconButton>
      {dialogOpen && (
      <NewDialog
        title={title}
        message={message}
        cancelLabel={cancelLabel}
        confirmLabel={confirmLabel}
        confirmButtonType="error"
        loading={loading}
        onConfirm={handleSubmit}
        onCancel={() => {
          handleClose();
        }}
        onClose={() => {
          handleClose();
        }}
        showCloseIcon={false}
      />
      )}
    </div>
  );
};

RemoveButton.defaultProps = {
  className: '',
  dialogProps: {},
  loadPreviousResource: false,
};

RemoveButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  dialogProps: PropTypes.object,
  loadPreviousResource: PropTypes.bool,
};

export default withStyles(styles)(RemoveButton);
